import { Component } from '@angular/core';
import { Observable } from 'rxjs';

import { ErrorService } from '../../services/error.service';

@Component({
  selector: 'app-error-banner',
  templateUrl: './error-banner.component.html',
  styleUrls: ['./error-banner.component.scss'],
  standalone: false,
})
export class ErrorBannerComponent {
  error$: Observable<string | null>;

  constructor(private errorService: ErrorService) {
    this.error$ = this.errorService.error$;
  }

  dismissError(): void {
    this.errorService.clearError();
  }
}
